'use strict';

module.exports = {
  number: 'number',
  str: 'str',
  boolean: 'boolean',
  alphanumeric: 'alphanumeric',
};
